import React, {Component} from 'react';

import './CollapsibleList.css';

export default class CollapsibleList extends Component {
	constructor(props) {
		super(props);

		this.state = {
			collapsed: true
		};
	}

	render() {
		return (
			<div className="CollapsibleList">
				<div
					className="Heading"
					onClick={() =>
						this.setState(prevState => ({
							collapsed: !prevState.collapsed
						}))
					}>
					<span>{this.props.title}</span>
					{this.state.collapsed ? (
						<span className="icon icon-keyboard_arrow_down" />
					) : (
						<span className="icon icon-keyboard_arrow_up" />
					)}
				</div>
				{!this.state.collapsed && <ul>{this.props.children}</ul>}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/widgets/CollapsibleList.js